query useIssuesByKeyWithChildrenQuery($cloudId: ID!, $keys: [String!]!) {
  jira {
    issuesByKey(cloudId: $cloudId, keys: $keys) {
      key
      webUrl
      childIssues {
        ... on JiraChildIssuesWithinLimit {
          issues {
            edges {
              node {
                id
                key
              }
            }
          }
        }
      }
    }
  }
}
